import { render, staticRenderFns } from "./Passwordplus.vue?vue&type=template&id=6f02452f&"
import script from "./Passwordplus.vue?vue&type=script&lang=js&"
export * from "./Passwordplus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports